import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./Trackyourorder.css";
import NoProducts from "./NoProducts";
import TrackOrderSkeleton from "../SkeletonLoader/TrackOrderSkeleton";

const Trackyourorder = () => {
  const [loading, setLoading] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [booking, setBooking] = useState([]);
  const navigate = useNavigate();
  const [noProductsFound, setNoProductsFound] = useState(false);
  const [userData] = useState(() => {
    const storedData = sessionStorage.getItem("user");
    return storedData ? JSON.parse(storedData) : null;
  });

  useEffect(() => {
    setLoading(true);
    if (!userData || !userData.email) {
      navigate("/login");
    } else {
      axios
        .get(
          `https://api.dremerz.net/api/Kalanjiyam_User_Order_Product_Checkout?user_email=${userData.email}`
        )
        .then((response) => {
          setBooking(response.data);
          if (response.data.length === 0) {
            setNoProductsFound(true);
          }
        })
        .catch((error) => {
          console.error("Error fetching booking data:", error);
        }).finally(() => {
          setLoading(false);
        });
    }
  }, [userData, navigate, userData]);

  const handleViewDetails = (order) => {
    setSelectedOrder(order);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedOrder(null);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Order Placed":
        return "#920504";
      case "Dispatched":
        return "#920504";
      case "Out for Delivery":
        return "#920504";
      case "Delivered":
        return "#28a745";
      default:
        return "#6c757d";
    }
  };

  if (loading)  return <TrackOrderSkeleton />;;

  return (
    <div>
      {noProductsFound ? (
        <div className="my-4 py-3">
          <NoProducts /> 
        </div>
      ) : (
        <div>

          <div className="container my-4 my-md-5">
            <h2 className="mb-4 page-title">Your Orders</h2>
            <div className="row">
              {booking?.toReversed().map((item, index) => (
                <div className="col-12 col-lg-6 mb-4" key={index}>
                  <div className="order-card">
                    <div className="order-card-header">
                      <span className="order-id">Order {item.bookingid}</span>
                      <span
                        className="order-status text-center"
                        style={{ backgroundColor: getStatusColor(item.status) }}
                      >
                        {item.status}
                      </span>
                    </div>
                    <div className="order-card-body">
                      <div className="order-image">
                        <img
                          src={`https://api.dremerz.net/uploads/${item.product_image}`}
                          alt={item.product_name}
                          loading="lazy"
                        />
                      </div>
                      <div className="order-details">
                        <h5>{item.product_name}</h5>
                        <p>Quantity: {item.product_quantity}</p>
                        <p>Total: ₹{item.product_grand_total}</p>
                        <p>Ordered on: {item.date_time}</p>
                      </div>
                    </div>
                    <div className="order-card-footer">
                      <button
                        className="view-details-btn"
                        onClick={() => handleViewDetails(item)}
                      >
                        View Details
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {showModal && selectedOrder && (
            <div className="modal-overlay" onClick={closeModal}>
              <div className="order-details-modal p-3" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                  <h4>Order {selectedOrder.bookingid}</h4>
                  <button className="close-modal" onClick={closeModal}>
                    &times;
                  </button>
                </div>
                <div className="modal-body">
                  {/* Product Image and Details - Side by side on desktop, stacked on mobile */}
                  <div className="row mb-4">
                    <div className="col-md-5 mb-3 mb-md-0">
                      <div className="modal-product-image">
                        <img
                          src={`https://api.dremerz.net/uploads/${selectedOrder.product_image}`}
                          alt={selectedOrder.product_name}
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <div className="col-md-7">
                      <div className="modal-product-details">
                        <h4>{selectedOrder.product_name}</h4>
                        <div className="detail-row">
                          <span className="detail-label">Price:</span>
                          <span className="detail-value">₹{selectedOrder.product_price}</span>
                        </div>
                        <div className="detail-row">
                          <span className="detail-label">Quantity:</span>
                          <span className="detail-value">{selectedOrder.product_quantity}</span>
                        </div>
                        {selectedOrder.dress_size !== "" && selectedOrder.dress_size !== "null" && (
                          <div className="detail-row">
                            <span className="detail-label">Size:</span>
                            <span className="detail-value">{selectedOrder.dress_size}</span>
                          </div>
                        )}
                        <div className="detail-row">
                          <span className="detail-label">Total Amount:</span>
                          <span className="detail-value">₹{selectedOrder.product_grand_total}</span>
                        </div>
                        <div className="detail-row">
                          <span className="detail-label">Order Date:</span>
                          <span className="detail-value">{selectedOrder.date_time}</span>
                        </div>
                        <div className="detail-row">
                          <span className="detail-label">Status:</span>
                          <span className="detail-value status-badge" style={{ backgroundColor: getStatusColor(selectedOrder.status) , maxWidth:"fit-content"}}>
                            {selectedOrder.status}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Shipping Details and Order Tracking */}
                  <div className="row">
                    <div className="col-md-6 mb-4 mb-md-0">
                      <div className="shipping-details">
                        <h5>Shipping Details</h5>
                        <div className="detail-row">
                          <span className="detail-label">Address:</span>
                          <span className="detail-value">{selectedOrder.address}</span>
                        </div>
                        <div className="detail-row">
                          <span className="detail-label">Pincode:</span>
                          <span className="detail-value">{selectedOrder.pincode}</span>
                        </div>
                        <div className="detail-row">
                          <span className="detail-label">Phone:</span>
                          <span className="detail-value">{selectedOrder.mobile2}</span>
                        </div>
                        <div className="detail-row">
                          <span className="detail-label">Landmark:</span>
                          <span className="detail-value">{selectedOrder.landmark || "N/A"}</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="tracking-container">
                        <h5>Order Tracking</h5>
                        <div className="tracking-progress">
                          {[
                            {
                              status: "Order Placed",
                              icon: "fa-shopping-cart",
                              date: selectedOrder.date_time || "Not available",
                              key: "Order Placed",
                            },
                            {
                              status: "Dispatched",
                              icon: "fa-box",
                              date: selectedOrder.dispatched_date || "Not available",
                              key: "Dispatched",
                            },
                            {
                              status: "Out for Delivery",
                              icon: "fa-truck",
                              date: selectedOrder.delivery_date || "Not available",
                              key: "Out for Delivery",
                            },
                            {
                              status: "Delivered",
                              icon: "fa-check-circle",
                              date: selectedOrder.delivered_date || "Not available",
                              key: "Delivered",
                            },
                          ].map((step, index) => {
                            const currentStatusIndex = [
                              "Order Placed",
                              "Dispatched",
                              "Out for Delivery",
                              "Delivered",
                            ].indexOf(selectedOrder.status);
                            const isActive = index <= currentStatusIndex;
                            const isCompleted = index < currentStatusIndex;

                            return (
                              <div key={step.key} className="tracking-step-container">
                                <div className={`tracking-step ${isActive ? "active" : ""} ${isCompleted ? "completed" : ""}`}>
                                  <div className="step-icon">
                                    <i className={`fa ${step.icon}`}></i>
                                  </div>
                                  <div className="step-content">
                                    <div className="step-title">{step.status}</div>
                                    {isActive && step.date && (
                                      <div className="step-date">{step.date}</div>
                                    )}
                                  </div>
                                </div>
                                {index < 3 && (
                                  <div className={`step-connector ${isCompleted ? "completed" : ""}`}></div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button className="close-btn" onClick={closeModal}>
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}

        </div>
      )}
    </div>
  );
};

export default Trackyourorder;